export async function initServiceWorker() {
  // Service worker registered for future background notifications only
  if (!("serviceWorker" in navigator)) return;
  try {
    await navigator.serviceWorker.register("/sw.js");
  } catch (e) {
    console.warn("[SW] registration failed:", e.message);
  }
}

export async function requestNotifyPermission() {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  try {
    const result = await Notification.requestPermission();
    return result === "granted";
  } catch {
    return false;
  }
}

// Uses plain Notification API — works immediately without waiting for SW activation.
// SW showNotification silently fails until SW is "activated" (requires a page refresh).
export function showBrowserNotification(title, body, tag) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, {
      body: body || "",
      icon: "/logo192.png",
      tag,
      renotify: false,
    });
    n.onclick = () => { window.focus(); n.close(); };
    setTimeout(() => n.close(), 8000);
  } catch (e) {
    console.warn("[Notify] failed:", e.message);
  }
}
